export default {
    'name': 'caret-light',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M17.7244 16.2931C18.1149 16.6837 18.7481 16.6837 19.1386 16.2931C19.5291 15.9026 19.5291 15.2695 19.1386 14.8789L12.121 7.86125C11.9334 7.67372 11.6791 7.56836 11.4138 7.56836C11.1486 7.56836 10.8943 7.67372 10.7067 7.86125L3.68907 14.8789C3.29855 15.2695 3.29855 15.9026 3.68907 16.2931C4.0796 16.6837 4.71276 16.6837 5.10329 16.2931L11.4138 9.98257L17.7244 16.2931Z\' fill=\'#FF4171\'/>'
}
